import createIcon from '../../createIcon';

/**
 * @component @name Refresh
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNjQ0OSA2LjM1QzE2LjE5NDkgNC45IDE0LjIwNDkgNCAxMS45OTQ5IDRDNy41NzQ4OCA0IDQuMDA0ODggNy41OCA0LjAwNDg4IDEyQzQuMDA0ODggMTYuNDIgNy41NzQ4OCAyMCAxMS45OTQ5IDIwQzE1LjcyNDkgMjAgMTguODM0OSAxNy40NSAxOS43MjQ5IDE0SDE3LjY0NDlDMTYuODI0OSAxNi4zMyAxNC42MDQ5IDE4IDExLjk5NDkgMThDOC42ODQ4OCAxOCA1Ljk5NDg4IDE1LjMxIDUuOTk0ODggMTJDNS45OTQ4OCA4LjY5IDguNjg0ODggNiAxMS45OTQ5IDZDMTMuNjU0OSA2IDE1LjEzNDkgNi42OSAxNi4yMTQ5IDcuNzhMMTIuOTk0OSAxMUgxOS45OTQ5VjRMMTcuNjQ0OSA2LjM1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Refresh = createIcon('Refresh', [
  [
    'path',
    {
      d: 'M17.6449 6.35C16.1949 4.9 14.2049 4 11.9949 4C7.57488 4 4.00488 7.58 4.00488 12C4.00488 16.42 7.57488 20 11.9949 20C15.7249 20 18.8349 17.45 19.7249 14H17.6449C16.8249 16.33 14.6049 18 11.9949 18C8.68488 18 5.99488 15.31 5.99488 12C5.99488 8.69 8.68488 6 11.9949 6C13.6549 6 15.1349 6.69 16.2149 7.78L12.9949 11H19.9949V4L17.6449 6.35Z',
      key: '1wsech',
    },
  ],
]);

export default Refresh;
